var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTahnologyTailwindQwik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-qwik-2",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18b6f6",
    style: {
      fill: "var(--color1, #18b6f6)"
    },
    d: "M21.236 25.99l-3.586-3.565-0.055 0.008v-0.039l-7.624-7.528 1.879-1.813-1.105-6.333-5.237 6.488c-0.892 0.899-1.056 2.362-0.414 3.44l3.272 5.427c0.5 0.837 1.409 1.337 2.387 1.329l1.62-0.016 8.862 2.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ac7ef4",
    style: {
      fill: "var(--color2, #ac7ef4)"
    },
    d: "M23.193 13.082l-0.721-1.329-0.376-0.68-0.149-0.265-0.016 0.016-1.971-3.416c-0.494-0.86-1.418-1.392-2.42-1.384l-1.73 0.047-5.159 0.016c-0.978 0.008-1.871 0.523-2.365 1.36l-3.139 6.223 5.613-6.966 7.359 8.083-1.309 1.321 0.784 6.325 0.008-0.016v0.016h-0.016l0.016 0.016 0.611 0.594 2.966 2.901c0.125 0.117 0.329-0.024 0.243-0.172l-1.832-3.603 3.194-5.903 0.102-0.118c0.039-0.047 0.078-0.094 0.11-0.141 0.625-0.851 0.712-1.993 0.196-2.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color3, #fff)"
    },
    d: "M18.144 14.755l-7.383-8.044 1.048 6.301-1.879 1.821 7.649 7.591-0.69-6.301 1.254-1.368z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tailwind-2",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38bdf8",
    style: {
      fill: "var(--color4, #38bdf8)"
    },
    d: "M14.138 8.282c-3.017 0-4.903 1.699-5.657 5.1 1.131-1.701 2.451-2.337 3.96-1.913 0.86 0.243 1.475 0.946 2.156 1.725 1.11 1.269 2.394 2.736 5.199 2.736 2.965 0 4.837-1.641 5.617-4.924v-0.115c-1.122 1.655-2.429 2.272-3.919 1.853-0.862-0.243-1.477-0.947-2.157-1.725-1.11-1.269-2.393-2.737-5.197-2.737zM8.481 15.93c-3.017 0-4.903 1.699-5.657 5.1 1.131-1.701 2.451-2.337 3.959-1.913 0.861 0.243 1.477 0.945 2.157 1.725 1.11 1.269 2.394 2.736 5.199 2.736 3.017 0 4.903-1.698 5.657-5.099-1.131 1.7-2.451 2.337-3.96 1.913-0.861-0.243-1.477-0.947-2.157-1.725-1.109-1.269-2.394-2.737-5.197-2.737z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTahnologyTailwindQwik);
export default __webpack_public_path__ + "static/media/tahnology-tailwind-qwik.f4298253a54bae21e6949978199983a2.svg";
export { ForwardRef as ReactComponent };